<script>
export default {};
</script>

<template>
    <!--START COBERTURAS-->

    <section class="section pt-5" id="coberturas">
        <div class="container">
            <h3 align="center">Coberturas disponibles<br></h3>
            <div class="section-title-border margin-t-20"></div>
            <div class="row margin-t-30" style="margin-left: -6px">
                <table align="center" class="coverage-table">
                    <thead>
                        <tr>
                            <td style="background-color: #81cc86; color: white;"></td>
                            <td colspan="4" style="background-color: #81cc86; color: white;">Paquetes de cobertura</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr style="background-color: #81cc86; color: white;">
                            <td></td>
                            <td>Platino</td>
                            <td>Amplio</td>
                            <td>Limitado</td>
                            <td>Básico</td>
                        </tr>
                        <tr>
                            <td>Daños materiales</td>
                            <td style="color: #00ff00;">✔</td>
                            <td style="color: #00ff00;">✔</td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr align="center">
                            <td>Robo total</td>
                            <td style="color: #00ff00;">✔</td>
                            <td style="color: #00ff00;">✔</td>
                            <td style="color: #00ff00;">✔</td>
                            <td></td>
                        </tr>
                        <tr align="center">
                            <td>Responsabilidad Civil</td>
                            <td style="color: #00ff00;">✔</td>
                            <td style="color: #00ff00;">✔</td>
                            <td style="color: #00ff00;">✔</td>
                            <td style="color: #00ff00;">✔</td>
                        </tr>
                        <tr align="center">
                            <td>Gastos Médicos</td>
                            <td style="color: #00ff00;">✔</td>
                            <td style="color: #00ff00;">✔</td>
                            <td style="color: #00ff00;">✔</td>
                            <td style="color: #00ff00;">✔</td>
                        </tr>
                        <tr align="center">
                            <td>Defensa Legal</td>
                            <td style="color: #00ff00;">✔</td>
                            <td style="color: #00ff00;">✔</td>
                            <td style="color: #00ff00;">✔</td>
                            <td style="color: #00ff00;">✔</td>
                        </tr>
                        <tr align="center">
                            <td>Asistencia Vial</td>
                            <td style="color: #00ff00;">✔</td>
                            <td style="color: #00ff00;">✔</td>
                            <td style="color: #00ff00;">✔</td>
                            <td style="color: #00ff00;">✔</td>
                        </tr>
                        <tr align="center">
                            <td>Cobertura Platino</td>
                            <td style="color: #00ff00;">✔</td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div><br><br>
        <section class="section section-lg bg-web-desc">
            <div class="bg-overlay2"
                :style="{ 'background-image': 'url(' + require('@/assets/images/ejemplo-5.jpg') + ')', 'background-size': 'cover', 'background-attachment': 'fixed' }">
            </div>
            <div class="container">
                <div class="row">
                    <div class="col-lg-12 text-center">
                        <h3 class="text-black text-muted2-2">¡Cotiza en línea!</h3>
                        <h2 class="text-black">Las coberturas indicadas para disfrutar tu viaje</h2>
                        <div class="section-title-border margin-t-20"></div>
                        <a href="https://public.nhseguros.com/#!policyindividual/index?code=22807&lang=es" target="_blank"
                            class="btn btn-custom btn-rounded margin-t-30 waves-effect waves-light">Compra tu seguro</a>
                    </div>
                </div>
            </div>
            <div class="bg-pattern-effect">
                <img src="@/assets/images/bg-pattern.png" alt />
            </div>
        </section>
    </section>
    <!--START COBERTURAS-->
</template>
<style scoped>
.coverage-table {
    width: 80%;
    min-width: 100%;
    margin: 0 auto;
    border-collapse: collapse;
    text-align: center;
}

td {
    border: 1px solid #ddd;
    position: relative;
    height: 50px;
}

tr:nth-child(even) {
    background-color: #ECF0F1;
    /* Gris claro */
}

tr:nth-child(odd) {
    background-color: #fff;
    /* Blanco */
}

@media (max-width: 414px) {

    .container {
        padding-left: 40px
    }
}</style>